<template>
  <div>
    <v-app-bar app dark flat class="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-row>
        <v-col md="4">
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
            :return-value.sync="startDate"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Start date"
                v-model="startDateUK"
                prepend-icon="event"
                hide-details
                readonly
                v-on="on"
                class="mt-3 mr-5"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              @input="$refs.menu.save(startDate)"
              min="2016-06-20"
              :max="endDate"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4">
          <v-menu
            ref="menu2"
            :close-on-content-click="false"
            v-model="menu2"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
            :return-value.sync="endDate"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="End date"
                v-model="endDateUK"
                prepend-icon="event"
                hide-details
                readonly
                class="mt-3"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              @input="$refs.menu2.save(endDate)"
              :min="startDate"
              :max="today"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-toolbar-items>
          <v-btn text @click="getData">Apply</v-btn>
        </v-toolbar-items>
      </v-row>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fill-height pt-2 class="grey lighten-2">
        <v-layout>
          <v-flex class="py-3">
            <span class="display-1 grey--text mt-2">Headlines</span>
            <v-card class="mt-2 mb-5">
              <v-tabs height="130" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab
                  class="statsTab"
                  @click="
                    activeChartName = 'DashboardPlatformRegistrations';
                    chartPrefix = null;
                    datasetName = 'Registrations';
                  "
                >
                  <StatsTab
                    title="Registrations"
                    :value="DashboardPlatformHeadlines.registrations"
                    :previousValue="PreviousDashboardPlatformHeadlines.registrations"
                    :currency="false"
                  ></StatsTab>
                </v-tab>
                <v-tab
                  class="statsTab"
                  @click="
                    activeChartName = 'DashboardPlatformNewEnquiriesCount';
                    chartPrefix = null;
                  "
                >
                  <StatsTab
                    title="Enquiries"
                    :value="DashboardPlatformHeadlines.enquiries"
                    :previousValue="PreviousDashboardPlatformHeadlines.enquiries"
                    :currency="false"
                  ></StatsTab>
                </v-tab>
                <v-tab
                  class="statsTab"
                  @click="
                    activeChartName = 'DashboardPlatformNewEnquiriesAvgRequested';
                    chartPrefix = '£';
                  "
                >
                  <StatsTab
                    title="Avg Funds Requested"
                    :value="DashboardPlatformHeadlines.avg_funding_requested"
                    :previousValue="PreviousDashboardPlatformHeadlines.avg_funding_requested"
                    :currency="true"
                  ></StatsTab>
                </v-tab>
                <v-tab
                  class="statsTab"
                  @click="
                    activeChartName = 'DashboardPlatformFundedEnquiriesAvg';
                    chartPrefix = '£';
                  "
                >
                  <StatsTab
                    title="Avg Funds Released"
                    :value="DashboardPlatformHeadlines.avg_funding_obtained"
                    :previousValue="PreviousDashboardPlatformHeadlines.avg_funding_obtained"
                    :currency="true"
                  ></StatsTab>
                </v-tab>
                <v-tab
                  class="statsTab"
                  @click="
                    activeChartName = 'DashboardPlatformFundedEnquiriesCount';
                    chartPrefix = '£';
                  "
                >
                  <StatsTab
                    title="Total Funds Released"
                    :value="DashboardPlatformHeadlines.total_funding_obtained"
                    :previousValue="PreviousDashboardPlatformHeadlines.total_funding_obtained"
                    :currency="true"
                  ></StatsTab>
                </v-tab>
              </v-tabs>
              <div class="pa-3">
                <HeadLineChart :chartData="chartData" :diff="0" :datasetName="datasetName" prefix="£"></HeadLineChart>
              </div>
            </v-card>
            <span class="display-1 grey--text mt-5">Enquiries</span>
            <v-layout>
              <v-flex>
                <v-layout column class="mr-3">
                  <v-subheader>New &amp; Expired</v-subheader>
                  <EnquiryCard
                    title="Pending"
                    :value="DashboardPlatformEnquiries.pending"
                    colour="indigo darken-4"
                    dark
                  ></EnquiryCard>
                  <EnquiryCard
                    title="Cancelled"
                    :value="DashboardPlatformEnquiries.sme_cancelled"
                    class="mt-2"
                    color="grey lighten-1"
                    dark
                  ></EnquiryCard>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout column class="mr-3">
                  <v-subheader>Enquiry Stages</v-subheader>
                  <EnquiryCard
                    title="Enquiry Accepted"
                    :value="DashboardPlatformEnquiries.enquiry_accepted"
                    colour="indigo darken-3"
                    dark
                  ></EnquiryCard>
                  <EnquiryCard
                    title="Enquiry Rejected"
                    :value="DashboardPlatformEnquiries.enquiry_rejected"
                    class="mt-2"
                    colour="indigo darken-3"
                    dark
                  ></EnquiryCard>
                  <EnquiryCard
                    title="Expired"
                    :value="DashboardPlatformEnquiries.expired"
                    class="mt-2"
                    colour="indigo darken-3"
                    dark
                  ></EnquiryCard>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout column class="mr-3">
                  <v-subheader>Funder Offer</v-subheader>
                  <EnquiryCard
                    title="Funder Offer Made"
                    :value="DashboardPlatformEnquiries.funder_offer_made"
                    colour="indigo darken-2"
                    dark
                  ></EnquiryCard>
                  <EnquiryCard
                    title="Funder Declined To Offer"
                    :value="DashboardPlatformEnquiries.funder_declined_to_offer"
                    class="mt-2"
                    colour="indigo darken-2"
                    dark
                  ></EnquiryCard>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout column class="mr-3">
                  <v-subheader>SME Offer</v-subheader>
                  <EnquiryCard
                    title="SME Offer Accepted"
                    :value="DashboardPlatformEnquiries.sme_offer_accepted"
                    colour="indigo darken-1"
                    dark
                  ></EnquiryCard>
                  <EnquiryCard
                    title="SME Offer Rejected"
                    :value="DashboardPlatformEnquiries.sme_offer_rejected"
                    class="mt-2"
                    colour="indigo darken-1"
                    dark
                  ></EnquiryCard>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout column class="mr-3">
                  <v-subheader>£££</v-subheader>
                  <EnquiryCard
                    title="Funding Released"
                    :value="DashboardPlatformEnquiries.funding_released"
                    colour="indigo"
                    dark
                  ></EnquiryCard>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import HeadLineChart from './Components/HeadLineChart';
import StatsTab from './Components/StatsTab';
import EnquiryCard from './Components/EnquiryCard';

export default {
  name: 'Platform',
  components: { HeadLineChart, EnquiryCard, StatsTab },
  data: () => ({
    startDate: moment()
      .subtract(6, 'days')
      .format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    today: moment().format('YYYY-MM-DD'),
    menu: false,
    menu2: false,
    tabs: null,
    datasetName: 'Registrations',
    activeChartName: 'DashboardPlatformRegistrations',
    chartPrefix: null
  }),
  computed: {
    ...mapGetters([
      'DashboardPlatformHeadlines',
      'PreviousDashboardPlatformHeadlines',
      'DashboardPlatformEnquiries',
      'DashboardPlatformChartData',
      'UILeftDrawer'
    ]),
    startDateUK: function() {
      return moment(this.startDate).format('DD/MM/YYYY');
    },
    endDateUK: function() {
      return moment(this.endDate).format('DD/MM/YYYY');
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    chartData: function() {
      return this.DashboardPlatformChartData(this.activeChartName);
    }
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState']),
    getData: function() {
      this.$store.dispatch('getPlatformData', {
        startDate: this.startDate,
        endDate: this.endDate
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style type="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.statsTab div {
  text-transform: none;
  text-align: left;
  width: 200px;
  padding: 20px 16px;
}

.application.theme--light {
  background: #e0e0e0;
}

.active--link {
  font-weight: 600 !important;
  background: #cebacd;
  border-radius: 0 25px 25px 0;
}
</style>
